// import React from "react";
// import { Link } from "react-router-dom";
// import "./SmartTechnology.css";

// export default function SmartTechnology() {
//   return (
//     <section
//       id="smart-tech"
//       className="hlc-smart hlc-smart--fullbleed"
//       aria-label="Smart Technology and Innovation"
//     >
//       <div className="hlc-smart__inner">
//         <div className="smart-head">
//           <p className="smart-eyebrow">Smart Features</p>
//           <h2 className="smart-title">SMARTER LIGHTING BETTER LIVING</h2>
//           <p className="smart-sub">
//         Advance lighting solutions built for efficiency, control, and modern living.
//           </p>
//         </div>

//         {/* === 4 CARDS === */}
//         <div className="smart-grid smart-grid--4">
//           {/* Smart Sensors */}
//           <article className="smart-card">
//             <div className="icon-wrap" aria-hidden="true">
//        <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
//   <path d="M6 2h12L16 9Q12 13 8 9Z" fill="rgba(255,255,255,0.15)" stroke="white"/>
//   <path d="M6 22h12L16 15Q12 11 8 15Z" fill="rgba(255,255,255,0.15)" stroke="white"/>
//   <line x1="5" y1="2" x2="19" y2="2"/>
//   <line x1="5" y1="22" x2="19" y2="22"/>
//   <circle cx="12" cy="12" r="1" fill="white" stroke="none"/>
// </svg>
//             </div>
//             <h3>Long Lasting</h3>
//             <p>
//               Built for durability with extended lifespan performance.
//             </p>
//           </article>

//           {/* App & Voice Control */}
//           <article className="smart-card">
//             <div className="icon-wrap" aria-hidden="true">
//          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
//   <path d="M12 2C18 4 22 10 20 16C18 21 11 23 6 19C1 15 3 7 12 2Z" fill="rgba(255,255,255,0.15)"/>
//   <polyline points="14,6 10,13 14,13 10,20" fill="none" stroke="white" strokeWidth="1.7"/>
// </svg>
//             </div>
//             <h3>Energy Efficient</h3>
//             <p>
//               Consumes less power while delivering maximum output.
//             </p>
//           </article>

//           {/* Energy Monitoring */}
//           <article className="smart-card">
//             <div className="icon-wrap" aria-hidden="true">
//           <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
//   <path d="M2 12Q12 3 22 12Q12 21 2 12Z" fill="rgba(255,255,255,0.1)"/>
//   <circle cx="12" cy="12" r="3.5" fill="rgba(255,255,255,0.2)"/>
//   <line x1="5" y1="20" x2="19" y2="20"/>
//   <line x1="9" y1="18" x2="9" y2="22"/>
//   <line x1="15" y1="18" x2="15" y2="22"/>
// </svg>
//             </div>
//             <h3>Flicker Free Illumination</h3>
//             <p>
//             Smooth, stable lighting that reduces eye strain.
//             </p>
//           </article>

//           {/* Seamless Integration */}
//           <article className="smart-card">
//             <div className="icon-wrap" aria-hidden="true">
//         <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
//   <circle cx="12" cy="12" r="4" fill="rgba(255,255,255,0.2)"/>
//   <line x1="12" y1="2" x2="12" y2="5"/>
//   <line x1="12" y1="19" x2="12" y2="22"/>
//   <line x1="2" y1="12" x2="5" y2="12"/>
//   <line x1="19" y1="12" x2="22" y2="12"/>
//   <line x1="4.9" y1="4.9" x2="7.1" y2="7.1"/>
//   <line x1="16.9" y1="16.9" x2="19.1" y2="19.1"/>
//   <line x1="19.1" y1="4.9" x2="16.9" y2="7.1"/>
//   <line x1="7.1" y1="16.9" x2="4.9" y2="19.1"/>
// </svg>
//             </div>
//             <h3>High Lumen Efficiency</h3>
//             <p>
//              Brighter light output with optimized energy usage.
//             </p>
//           </article>
//         </div>

//         <div className="smart-cta smart-cta--bottom">
//           <Link className="smart-btn" to="/categories">
//             Explore Technology →
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// }


import React, { useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./SmartTechnology.css";

gsap.registerPlugin(ScrollTrigger);

const FEATURES = [
  {
    key: "long-lasting",
    title: "Long Lasting",
    text: "Built for durability with extended lifespan performance.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2h12L16 9Q12 13 8 9Z" fill="rgba(255,255,255,0.14)" />
        <path d="M6 22h12L16 15Q12 11 8 15Z" fill="rgba(255,255,255,0.14)" />
        <line x1="5" y1="2" x2="19" y2="2" />
        <line x1="5" y1="22" x2="19" y2="22" />
      </svg>
    ),
  },
  {
    key: "energy",
    title: "Energy Efficient",
    text: "Consumes less power while delivering maximum output.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C18 4 22 10 20 16C18 21 11 23 6 19C1 15 3 7 12 2Z" fill="rgba(255,255,255,0.14)" />
        <polyline points="14,6 10,13 14,13 10,20" fill="none" strokeWidth="1.7" />
      </svg>
    ),
  },
  {
    key: "flicker-free",
    title: "Flicker Free Illumination",
    text: "Smooth, stable lighting that reduces eye strain.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12Q12 4 22 12Q12 20 2 12Z" fill="rgba(255,255,255,0.1)" />
        <circle cx="12" cy="12" r="3.4" fill="rgba(255,255,255,0.2)" />
      </svg>
    ),
  },
  {
    key: "lumen",
    title: "High Lumen Efficiency",
    text: "Brighter light output with optimized energy usage.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="4" fill="rgba(255,255,255,0.2)" />
        <line x1="12" y1="2" x2="12" y2="5" /><line x1="12" y1="19" x2="12" y2="22" />
        <line x1="2" y1="12" x2="5" y2="12" /><line x1="19" y1="12" x2="22" y2="12" />
        <line x1="4.9" y1="4.9" x2="7.1" y2="7.1" /><line x1="16.9" y1="16.9" x2="19.1" y2="19.1" />
        <line x1="19.1" y1="4.9" x2="16.9" y2="7.1" /><line x1="7.1" y1="16.9" x2="4.9" y2="19.1" />
      </svg>
    ),
  },
];

export default function SmartTechnology() {
  const root = useRef(null);
  const [active, setActive] = React.useState(0);
  const pausedRef = useRef(false);

  /* ---- auto-rotating spotlight: one card 'active' at a time ----
     cycles every 2.6s; hovering the grid pauses it and hover selects. */
  useLayoutEffect(() => {
    const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (REDUCED) return;
    const id = setInterval(() => {
      if (pausedRef.current) return;
      setActive((a) => (a + 1) % FEATURES.length);
    }, 2600);
    return () => clearInterval(id);
  }, []);

  useLayoutEffect(() => {
    const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (REDUCED) return;
    const ctx = gsap.context(() => {
      /* ---- scroll-choreographed entrance ---- */
      gsap.from(".smart-head > *", {
        y: 26, opacity: 0, duration: 0.8, stagger: 0.1, ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 80%" },
      });
      /* reveal cards with fromTo so the end state is explicit and can't
         get stuck at opacity:0; toggleActions replays sanely */
      gsap.fromTo(".smart-card",
        { y: 42, opacity: 0 },
        {
          y: 0, opacity: 1, duration: 0.9, stagger: 0.12, ease: "power3.out",
          scrollTrigger: { trigger: ".smart-grid", start: "top 85%", once: true },
        }
      );
      gsap.from(".smart-cta", {
        y: 20, opacity: 0, duration: 0.7, ease: "power3.out",
        scrollTrigger: { trigger: ".smart-cta", start: "top 92%", once: true },
      });

      /* ---- parallax: drift the ICON (not the whole card) so it never
         fights the reveal transform on .smart-card ---- */
      if (!REDUCED) {
        gsap.to(".smart-card .icon-wrap", {
          yPercent: (i) => (i % 2 === 0 ? -12 : -20),
          ease: "none",
          scrollTrigger: { trigger: root.current, start: "top bottom", end: "bottom top", scrub: 0.6 },
        });
        gsap.to(".smart-aura", {
          backgroundPosition: "60% 40%",
          ease: "none",
          scrollTrigger: { trigger: root.current, start: "top bottom", end: "bottom top", scrub: 1 },
        });
      }
    }, root);

    /* ---- cursor-following 3D tilt + glow per card ---- */
    let handlers = [];
    if (!REDUCED && !isTouch) {
      const cards = root.current.querySelectorAll(".smart-card");
      cards.forEach((card) => {
        const move = (e) => {
          const b = card.getBoundingClientRect();
          const px = (e.clientX - b.left) / b.width - 0.5;
          const py = (e.clientY - b.top) / b.height - 0.5;
          card.style.transform =
            `perspective(800px) rotateX(${(-py * 12).toFixed(2)}deg) rotateY(${(px * 14).toFixed(2)}deg) translateY(-6px) translateZ(16px)`;
          card.style.setProperty("--mx", `${(px + 0.5) * 100}%`);
          card.style.setProperty("--my", `${(py + 0.5) * 100}%`);
        };
        const leave = () => { card.style.transform = ""; };
        card.addEventListener("pointermove", move);
        card.addEventListener("pointerleave", leave);
        handlers.push([card, move, leave]);
      });
    }

    return () => {
      ctx.revert();
      handlers.forEach(([c, m, l]) => {
        c.removeEventListener("pointermove", m);
        c.removeEventListener("pointerleave", l);
      });
    };
  }, []);

  return (
    <section
      id="smart-tech"
      className="hlc-smart hlc-smart--fullbleed"
      aria-label="Smart Technology and Innovation"
      ref={root}
    >
      <span className="smart-aura" aria-hidden="true" />
      <span className="smart-particles" aria-hidden="true">
        {Array.from({ length: 5 }).map((_, i) => (
          <span key={i} className={`sp sp--${i + 1}`} />
        ))}
      </span>

      <div className="hlc-smart__inner">
        <div className="smart-head">
          <p className="smart-eyebrow">Smart Features</p>
          <h2 className="smart-title">SMARTER LIGHTING BETTER LIVING</h2>
          <p className="smart-sub">
            Advance lighting solutions built for efficiency, control, and modern living.
          </p>
        </div>

        <div
          className="smart-grid smart-grid--4"
          onPointerEnter={() => { pausedRef.current = true; }}
          onPointerLeave={() => { pausedRef.current = false; }}
        >
          {FEATURES.map((f, i) => (
            <article
              className={`smart-card smart-card--${f.key}${i === active ? " is-active" : ""}`}
              key={f.key}
              onPointerEnter={() => setActive(i)}
            >
              <span className="smart-card__sheen" aria-hidden="true" />
              <span className="smart-card__spot" aria-hidden="true" />
              <div className="icon-wrap" aria-hidden="true">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </article>
          ))}
        </div>

        <div className="smart-cta smart-cta--bottom">
          <Link className="smart-btn" to="/categories">
            Explore Technology <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
